export const getAddressUrl = market =>
  `https://maps.google.com/maps?daddr=${
    market?.address?.lat ?? market['address.lat']
  },${market?.address?.lat ?? market['address.lon']}&dirflg=d`
